import React, { useEffect } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans } from 'react-i18next';
import Crowd from '@app/illu/Image/Crowd.svg';
import { Categories, useTrack, useTrackingParams } from '@app/analytics';
import { useSessionLink, useShortUrl } from '@app/api';
import { useSearchParams } from 'react-router-dom';

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.h3,
    whiteSpace: 'pre-line',
  },
  subtitle: {
    ...theme.fonts.h5,
    marginTop: theme.marginBase * 7,
    textAlign: 'center',
  },
  imageContainer: {
    textAlign: 'center',
  },
  image: {
    margin: 'auto',
    width: 148,
    height: 148,
    marginTop: theme.marginBase * 7,
  },
}));

interface Props {
  sessionId?: string | null;
  sessionLinkId?: string;
}

export const CompletedSession = ({ sessionId, sessionLinkId}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const tracking = useTrackingParams();

  const shortUrl = useShortUrl();
  const { data: sessionLink } = useSessionLink(sessionLinkId);
  const [params] = useSearchParams();
  const hasRedirectedParam = params.has('redirected');

  const track = useTrack();
  useEffect(() => {
    track('Saw Completed Session Page', {
      category: Categories.GENERAL,
      label: sessionId || 'No Session',
      nonInteraction: true,
      sessionId: sessionId,
    });
  }, [sessionId]);

  useEffect(() => {
    if (hasRedirectedParam) {
      return;
    }
    if (sessionLink && sessionLink.redirectionLinksId) {
      const url = new URL(
        `${shortUrl}/session-links/${sessionLinkId}/full-redirection`,
      );
      Object.entries(tracking || {}).forEach(([key, value]) =>
        url.searchParams.set(key, String(value)),
      );
      // @ts-ignore
      window.location = url.toString();
    }
  }, [sessionLink, hasRedirectedParam]);

  return (
    <div>
      <h1 className={classes.title}>
        <Trans i18nKey="application.completed.title" />
      </h1>
      <div className={classes.imageContainer}>
        <img src={Crowd} alt="Illustration" className={classes.image} />
      </div>
      <p className={classes.subtitle}>
        <Trans i18nKey="application.completed.subtitle" />
      </p>
    </div>
  );
};
